import React from 'react';
// import PropTypes from 'prop-types';
import { Box, Text } from 'wt-ui';

const CalendarLegend = () => (
  <Box background="transparent" direction="row" gap="small" justify="between">
    <Text>Calendar events time is set to GMT timezone</Text>
    <Box background="transparent">
      Units:
      <Box background="transparent" direction="row" gap="medium">
        <Box background="transparent">
          <Text>
            <Text weight="bold">M Pounds</Text> - Million Pounds
          </Text>
          <Text>
            <Text weight="bold">M Bsh</Text> - Million Bushels
          </Text>
          <Text>
            <Text weight="bold">M MT</Text> - Million Metric Tons
          </Text>
        </Box>
        <Box background="transparent">
          <Text>
            <Text weight="bold">%</Text> - Percentage
          </Text>
          <Text>
            <Text weight="bold">1K Heads</Text> - Thousand Heads
          </Text>
          <Text>
            <Text weight="bold"># contr.</Text> - Number of Contracts{' '}
          </Text>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default CalendarLegend;
